import {GiftConstants } from '../constants';
export function Gift(state = {}, action) {
    switch (action.type) {
        case GiftConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };
        case GiftConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case GiftConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case GiftConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case GiftConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case GiftConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case GiftConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }
}